<form [formGroup]="shareProductTermsForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Total Number of Shares' | translate }}</mat-label>
      <input
        type="number"
        matInput
        matTooltip="{{ 'tooltips.Total number of shares that a product is offering' | translate }}"
        formControlName="totalShares"
        required
        min="1"
      />
      @if (shareProductTermsForm.get('totalShares').hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.Total Number of Shares' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
      @if (shareProductTermsForm.get('totalShares').hasError('min')) {
        <mat-error>
          {{ 'labels.inputs.Total Number of Shares' | translate }} must be at least <strong>1</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Shares to be Issued' | translate }}</mat-label>
      <input
        type="number"
        matInput
        matTooltip="{{ 'tooltips.Total number of shares that an orgranization' | translate }}"
        formControlName="sharesIssued"
        required
        min="1"
      />
      @if (shareProductTermsForm.get('sharesIssued').hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.Shares to be Issued' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
      @if (shareProductTermsForm.get('sharesIssued').hasError('min')) {
        <mat-error>
          {{ 'labels.inputs.Shares to be Issued' | translate }} must be at least <strong>1</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Nominal/Unit Price' | translate }}</mat-label>
      <input
        type="number"
        matInput
        matTooltip="{{ 'tooltips.Unit/Nominal Price of each share' | translate }}"
        formControlName="unitPrice"
        required
        min="1"
      />
      @if (shareProductTermsForm.get('unitPrice').hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.Nominal Price' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
      @if (shareProductTermsForm.get('unitPrice').hasError('min')) {
        <mat-error> {{ 'labels.inputs.Nominal Price' | translate }} must be at least <strong>1</strong> </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Capital Value' | translate }}</mat-label>
      <input
        type="number"
        matInput
        matTooltip="{{ 'tooltips.Total Capital Value' | translate }}"
        formControlName="shareCapital"
        readonly
      />
      <mat-hint>
        {{ 'labels.inputs.Shares to be Issued * Nominal Price (Auto calculated)' | translate }}
      </mat-hint>
    </mat-form-field>
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext>
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
